import type { ArticleData } from '../../src/viewers/components/types';
import type * as basket from '@easterngraphics/wcf/modules/eaiws/basket/index';

import { languageStore } from '../stores/LanguageStore';
import { ObxReader } from '../stores/ObxReader';

import {
    articleNumberEnum,
    decodeHtml,
    descriptionEnum,
    getArticle,
    getArticleNumber,
    getDescriptionText,
    getManufacturerNameFromDocument,
    getSeriesNameFromDocument,
} from './ViewerUtilities';

import { FALLBACK_LANGUAGE } from '@egr/xbox/base-app/i18n';

export function getUrlParamValue(url: string, param: string): string | null {
    if (url == '' || param == '') {
        return null;
    }
    const parsedUrl = new URL(url);
    // The url might contain a query param "edit" and param with an encoded "edit" parameter too.
    // if (pUrl.includes('sharepoint.com') && pParam === 'edit') {
    if (parsedUrl.host.endsWith('sharepoint.com') && param === 'edit') {
        return getSharePointParamEditValue(url);
    }

    return parsedUrl.searchParams.get(param);
}

export function getSharePointParamEditValue(pUrl: string): string | null {
    const parts: Array<string> = pUrl.split('edit=');
    const link: string | null = parts.length > 0 ? parts[1] : null;
    return link;
}

export function getArticleInformation(comIDs: Array<string>, articleDocumentObx: Document | null, logos: Map<string, string>): Array<ArticleData> {
    const langApp: string = languageStore.snapshot.language;
    const langDefault: string = FALLBACK_LANGUAGE;
    return comIDs
        .map((id) => {
            const articleElement = getArticle(articleDocumentObx, id);
            if (!articleElement) return null;

            const obxReader = new ObxReader();
            const elementData = obxReader.getArticleElementData(id, articleElement);

            const articleProperties: Array<basket.ArticleProperties> = obxReader.getArticleProperties(elementData);

            const manufacturerId: string = articleDocumentObx ? getManufacturerNameFromDocument(articleDocumentObx, articleElement, '', '', true) : '';

            let logoSrc: string | undefined;

            logos.forEach((value, key) => {
                if (key.toLowerCase().startsWith(manufacturerId.toLowerCase())) {
                    logoSrc = value;
                }
            });

            const data: ArticleData = {
                kind: 'article',
                id,
                logoSrc: logoSrc,
                imageLink: {
                    title: '',
                    url: '', // Todo
                },
                longText: getDescriptionText(articleElement, langApp, langDefault, descriptionEnum.long),
                featureText: getDescriptionText(articleElement, langApp, langDefault, descriptionEnum.features),
                baseArticleNumber: getArticleNumber(articleElement, articleNumberEnum.base),
                series: articleDocumentObx ? decodeHtml(getSeriesNameFromDocument(articleDocumentObx, articleElement, langApp, langDefault, false)) : '',
                manufacturer: articleDocumentObx ? decodeHtml(getManufacturerNameFromDocument(articleDocumentObx, articleElement, langApp, langDefault)) : '',
                specialText: elementData?.article?.specialText ?? '',
                additionalText: elementData?.article?.additionalText ?? '',
                articleProperties: articleProperties,
            };

            return data;
        })
        .filter((article) => article !== null);
}
